// Global open-state for `<GraduationHowItWorksModal />`.
//
// The modal mounts once at the app-shell level. The "What is graduation?"
// cross-link inside the Markets and Winners how-it-works modals flips `open`
// to true (after closing its own parent), so a single mounted modal serves
// every surface.

'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

export interface GraduationModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useGraduationModalStore: UseBoundStore<StoreApi<GraduationModalState>> =
  createTrackedStore<GraduationModalState>('useGraduationModalStore')((set) => ({
    open: false,
    setOpen: (open: boolean): void => set({ open }),
  }));
